import { Link, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Box, Button, Container, Typography } from '@mui/material'
import { finalizeGroupCheckoutSession } from '@batical/common'
import { useAuth } from 'src/contexts/AuthContext'

const rootStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
  py: 4
}

const finalizeStorageKey = (sessionId: string) => `batiweb_finalize_checkout_${sessionId}`

export function StripeSuccessPage() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')
  const { user } = useAuth()
  const [finalizeNote, setFinalizeNote] = useState<string | null>(null)

  useEffect(() => {
    if (!sessionId || !user?.uid) return
    let cancelled = false
    const key = finalizeStorageKey(sessionId)
    try {
      const st = sessionStorage.getItem(key)
      if (st === '1') return
      if (st === 'pending') return
      sessionStorage.setItem(key, 'pending')
    } catch {
      /* sessionStorage indisponible : on tente quand même une fois */
    }

    console.log('[StripeSuccessPage] finalizeGroupCheckoutSession → calling', { sessionId, uid: user?.uid })
    void finalizeGroupCheckoutSession(sessionId)
      .then(res => {
        console.log('[StripeSuccessPage] finalizeGroupCheckoutSession ← OK', res)
        if (cancelled) return
        try {
          sessionStorage.setItem(key, '1')
        } catch {
          /* ignore */
        }
        setFinalizeNote(null)
      })
      .catch((err: { code?: string; message?: string; details?: unknown }) => {
        console.error('[StripeSuccessPage] finalizeGroupCheckoutSession ← ERR', {
          code: err?.code,
          message: err?.message,
          details: err?.details,
          fullError: err
        })
        if (cancelled) return
        try {
          sessionStorage.removeItem(key)
        } catch {
          /* ignore */
        }
        const msg = err?.message ?? 'Synchronisation serveur impossible pour le moment.'
        setFinalizeNote(`${msg} (code: ${err?.code ?? 'unknown'})`)
      })

    return () => {
      cancelled = true
    }
  }, [sessionId, user?.uid])

  return (
    <Box sx={rootStyle}>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#2e7d32', mb: 2 }}>
            Paiement réussi
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Votre paiement est bien enregistré. L&apos;accès aux calculs se met à jour automatiquement après
            synchronisation avec Stripe (quelques secondes en général).
            {sessionId && ' La liste des membres sera également mise à jour sous peu.'}
          </Typography>
          {sessionId && !user?.uid ? (
            <Typography color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
              Connectez-vous avec le même compte que pour le paiement pour finaliser l&apos;ajout des membres
              (synchro serveur).
            </Typography>
          ) : null}
          {finalizeNote ? (
            <Typography color="error" sx={{ mb: 2, fontSize: '0.95rem' }}>
              {finalizeNote}
            </Typography>
          ) : null}
          <Button component={Link} to="/dashboard" variant="contained" size="large">
            Retour au tableau de bord
          </Button>
        </Box>
      </Container>
    </Box>
  )
}
